const locale = {
  placeholder: 'Demê hilbijêre',
};

export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/ku_IQ.tsx